import { endpoint } from "./utils.js";
import axios from 'axios';
import { objComparatorNumber } from "../utils.js";

export function issueRootURL() {
  return endpoint("internal/current/tickets/");
}

export async function fetchIssueById(issueId) {
  const url = `${issueRootURL()}${issueId}/`;
  const res = await axios.get(url, { withCredentials: true });
  return res.data;
}

export async function fetchParkIssues(parkId) {
  const final = [];
  let next = `${issueRootURL()}?park_id=${parkId}&is_solved=0`;
  while (next !== null) {
    const res = await axios.get(next, {
      withCredentials: true
    });
    final.push(...res.data['results']);
    next = res.data['next'] || null;
  }
  return final.sort((a, b) => objComparatorNumber(a, b, 'id')).map(el => {
    return { ...el, visual_name: `${el['id']} - ${el['title']}` };
  });
}

